<script lang="ts">
	import { DataHandlerDevice, DataHandlerSnapshot, DeviceGroup } from "luxedo-data"
	import CustomSelectInstance from "./CustomSelectInstance.svelte"

	interface Props {
		selectedSnapshotId: number
		selectedDeviceId: number
	}

	let { selectedSnapshotId, selectedDeviceId }: Props = $props()

	let resX: number = $state()
	let resY: number = $state()

	function updateResolution() {
		const device = DataHandlerDevice.get(selectedDeviceId)
		const snapshot = DataHandlerSnapshot.get(selectedSnapshotId)

		if (device instanceof DeviceGroup || !snapshot) {
			resX = device?.resX
			resY = device?.resY
		} else {
			resX = snapshot?.resolution.w
			resY = snapshot?.resolution.h
		}
	}

	$effect(() => {
		if (selectedSnapshotId || selectedDeviceId) updateResolution()
	})
</script>

<div class="flex-column">
	<h3 class="upload-header">Select your show</h3>

	<p>Browse our collection of professionally designed custom shows created by the Luxedo team:</p>
	<CustomSelectInstance
		img="/LuxedoLogo.svg"
		title="Luxedo"
		url="http://www.luxedo.com/collections/custom-shows"
	/>

	<p class="second-list">
		Or explore our trusted partners below to discover and purchase their custom shows:
	</p>
	<!-- <div class="link-list">
		<a target="_blank" href="https://www.jollyholidayshows.com/">Jolly Holiday Shows</a>
		<a target="_blank" href="https://fxprojections.com/videos-1">FX Projections</a>
		<a target="_blank" href="https://www.jesterlaughs.com/">Jester Laughs</a>
		<a target="_blank" href="https://holidayprojectionmapping.com/">Holiday Projection Mapping</a>
	</div> -->

	<div class="card-list">
		<CustomSelectInstance
			img="/content-creators/jolly-holiday.webp"
			title="Jolly Holiday Shows"
			url="https://www.jollyholidayshows.com"
		/>
		<CustomSelectInstance
			img="/content-creators/jester.webp"
			title="Jester Laughs"
			url="https://www.jesterlaughs.com/"
		/>
		<CustomSelectInstance
			img="/content-creators/hpm.png"
			title="Holiday Projection Mapping"
			url="https://holidayprojectionmapping.com/"
		/>
	</div>

	<p class="guide">
		When ordering, be sure to provide the correct resolution
		<span class="highlight">
			{#if resX && resY}
				({resX ?? "0"}x{resY ?? "0"})
			{/if}
		</span>
		and include your calibrated snapshot, which you can download in the next step.
	</p>
</div>

<style>
	h3 {
		margin-bottom: 1rem;
	}

	p {
		margin: 0 0 0 0;
		color: var(--color-text);
	}

	.highlight {
		color: var(--color-main);
	}

	.second-list {
		margin-top: 0.5rem;
	}

	.card-list {
		width: fit-content;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		gap: 0.5rem;
		margin: 0 0 1rem 0;
	}

	:global(.isMobile) .upload-header {
		display: none;
	}
</style>
